<template>
  <v-app class="home-page" :key="updateLanguage">
    <header-comp :activeButton="0" access="dealer" v-on:update="onStep1Update()" />
    <v-tabs centered @change="changeTab">
      <v-tab>{{ "lng_map_view_txt" | translate }}</v-tab>
      <v-tab>{{ "lng_list_view_txt" | translate }}</v-tab>
    </v-tabs>
    <div v-if="activeTab === 0" class="map-container">
      <v-row class="map-height">
        <v-col cols="12" v-if="systemData">
          <l-map :zoom="zoom" :center="center" style="height: 100%; width: 100%">
            <l-tile-layer :url="url" :attribution="attribution" />
            <l-marker
              v-for="item in systemData"
              :key="item.id"
              :lat-lng="[item.geolat ? item.geolat : 0, item.geolng ? item.geolng : 0]"
              v-on:click="markerClicked(item)"
            >
              <l-tooltip :content="renderMarkersTooltip(item)" />
              <l-icon :icon-anchor="staticAnchor" class-name="someExtraClass">
                <img :src="chooseMapPin(item.sysstate, 'map')" width="30px" />
              </l-icon>
            </l-marker>
          </l-map>
        </v-col>
      </v-row>
    </div>
    <div v-if="activeTab === 1" class="my-2">
      <v-row class="m-1" v-if="dealerDashbaord">
        <v-col cols="12" xs="12" sm="6" md="3" class="pa-2">
          <v-card>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="headline mb-1">
                  {{ dealerDashbaord['installs-this-month'] }}</v-list-item-title>
                <v-list-item-subtitle>{{ "lng_installs_this_month_txt" | translate }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="3" class="pa-2">
          <v-card>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="headline mb-1">
                  {{ dealerDashbaord['installs-this-year'] }}</v-list-item-title>
                <v-list-item-subtitle>{{ "lng_installs_this_year_txt" | translate }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="3" class="pa-2">
          <v-card>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="headline mb-1">
                  {{ dealerDashbaord['installs-total'] }}</v-list-item-title>
                <v-list-item-subtitle>{{ "lng_installs_total_txt" | translate }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="3" class="pa-2">
          <v-card>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="headline mb-1">
                  {{ dealerDashbaord['service-needed'] }}</v-list-item-title>
                <v-list-item-subtitle>{{ "lng_service_needed_txt" | translate }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
      <v-card class="ma-3">
        <v-card-title style="background: gainsboro;">
          {{ "lng_systems_list_txt" | translate }}
          <v-spacer></v-spacer>
          <!-- <v-btn class="mx-2" fab dark small color="#0B7894" @click="openAddSystemModal = true">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn> -->
          <v-btn class="mx-2" fab dark small color="#0B7894" @click="openFiltersModal = true">
            <v-icon dark>mdi-filter</v-icon>
          </v-btn>
        </v-card-title>
        <v-col v-if="systemData" cols="12" style="overflow: auto;" class="pa-0">
          <v-data-table
            :headers="headers"
            :items="filteredData"
            class="elevation-1"
            @click:row="markerClicked"
          >

          <template v-slot:item.full_address="{ item }">{{ item | formatAddress }}</template>
          <template v-slot:item.sysstate="{ item }">
            <v-chip v-if="item.sysstate === '0'" color="rgb(130,225,147)" dark x-small>{{ "lng_system_state_ok_txt" | translate }}</v-chip>
            <v-chip v-else-if="item.sysstate === '1'" color="rgb(225,128,128)" dark x-small>{{ "lng_system_state_alarm_txt" | translate }}</v-chip>
            <v-chip v-else-if="item.sysstate === '2'" color="rgb(223,217,217)" x-small>{{ "lng_system_state_offline_txt" | translate }}</v-chip>
          </template>
          <template v-slot:item.lastservice="{ item }">
            <v-chip v-if="findMonthsForService(item) === 'no'" color="rgb(130,225,147)" dark x-small>{{ "lng_no_service_txt" | translate }}</v-chip>
            <v-chip v-else-if="findMonthsForService(item) === 'soon'" color="rgb(225,128,128)" dark x-small>{{ "lng_soon_service_txt" | translate }}</v-chip>
            <v-chip v-else-if="findMonthsForService(item) === 'due'" color="rgb(223,217,217)" x-small>{{ "lng_due_service_txt" | translate }}</v-chip>
          </template>
          <template v-slot:item.id="{ item }">
            <span>{{ item.lastservice }}</span>
          </template>
          <template v-slot:item.employee="{ item }">
            <v-select
              v-model="item.employee"
              class="mt-0 pt-0"
              :items="employeesData"
              :value="employeesData.id"
              item-text="name"
              item-value="id"
              menu-props="auto"
              return-object
              @change="assignEmployee(item)"
            ></v-select>
          </template>
          <!-- <template #item="{ item }">
            <tr :class="chooseMapPin(sysstate, 'table')" >
              <td v-on:click="markerClicked(item)" style="cursor: pointer;">
                {{ item.user.email }}</td>
              <td>{{ item.user.address1 }} {{ item.user.city }} {{ item.user.country }}</td>
              <td>{{ alarmemail }}</td>
              <td>{{ alarmsms }}</td>
              <td>
                <v-select
                  class="mt-0 pt-0"
                  :items="employeesData"
                  :value="employeesData.name"
                  item-text="name"
                  item-value="name"
                  menu-props="auto"
                  return-object
                  
                ></v-select>
              </td>
            </tr> 
          </template> -->
          <!-- <template v-slot:items="props">
            <td>{{ props.item.id }}</td>
            <td class="text-xs-right">{{ props.item.name }}</td>
          </template>
          <template v-slot:item.action="{ item }">
            <v-icon style="cursor: pointer" @click="deleteEmployee(item)">mdi-trash-can</v-icon>
          </template> -->
            
          </v-data-table>
        </v-col>
      </v-card>
    </div>
    <UserInfoModal
      :dealer-token="dealerToken"
      :dialog-title="'lng_box_detail_key_txt' | translate"
      :system-data="systemItem"
      :openDialog="openInfoModal"
      :closeDialog="closeInfoModalFunc"
    ></UserInfoModal>
    <AddSystem
      :dealer-token="dealerToken"
      :dialog-title="'lng_add_system_toDealer_txt' | translate"
      :openDialog="openAddSystemModal"
      :closeDialog="closeAddSystemModalFunc"
    />
    <FiltersDialog
      :dealer-token="dealerToken"
      :dialog-title="'lng_choose_filters_txt' | translate"
      :openDialog="openFiltersModal"
      :closeDialog="closeFiltersModalFunc"
      :employees-data="employeesData"
      @applyFilters="applyFilters"
    />
  </v-app>
</template>

<script>
// @ is an alias to /src
import Menu from "../../components/Menu.vue";
import { LMap, LTileLayer, LMarker, LIcon, LTooltip } from "vue2-leaflet";
import L from "leaflet";
import GlobalService from "../../services/global-service";
import HeaderComp from "../../components/HeaderComp";
import router from "../../router";
import { translateFunc } from "../../common/Filters.js"
import UserInfoModal from "../../components/dealer/UserInfoModal"
import AddSystem from "../../components/dealer/AddSystem"
import FiltersDialog from "../../components/dealer/FiltersDialog"
import moment from "moment";
import onStep1Update from "../../mixins/ChangeLanguage"

export default {
  name: "DealerHome",
  components: {
    Menu,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LTooltip,
    HeaderComp,
    UserInfoModal,
    AddSystem,
    FiltersDialog
  },
  data() {
    return {
      dealerToken: undefined,
      employeesData:undefined,
      zoom: 8,
      center: L.latLng(56.426264, 9.957401),
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      markerLoc: L.latLng(56.426264, 9.957401),
      icon: L.icon({
        iconUrl: "../icons/user-icon.png",
        iconSize: [32, 37],
        iconAnchor: [16, 37]
      }),
      staticAnchor: [16, 37],
      systemData: undefined,      
      openInfoModal: false,
      openAddSystemModal: false,
      systemItem: {},
      clearAlarmCount: 0,
      testAlarmCount: 0,
      activeTab: 0,
      headers: [
        { text: translateFunc('lng_th_address_txt'), value: 'full_address' },
        { text: translateFunc('lng_th_alarm_email_txt'), value: 'alarmemail' },
        { text: translateFunc('lng_th_alarm_phone_txt'), value: 'alarmsms' },
        { text: translateFunc('lng_th_sewer_type_txt'), value: 'sewertype' },
        { text: translateFunc('lng_th_comment_txt'), value: 'internalcomment' },
        { text: translateFunc('lng_th_service_date_txt'), value: 'id' },
        { text: translateFunc('lng_th_sysStatus_txt'), value: 'lastservice' },
        { text: translateFunc('lng_th_sysState_txt'), value: 'sysstate' },
        { text: translateFunc('lng_th_assign_employee_txt'), value: "employee" },
      ],
      tableItems: [],
      employeesData: undefined,
      listLoading: false,
      dealerDashbaord: undefined,
      openFiltersModal: false,
      filteredData: undefined
    };
  },
  mounted() {
    let token = localStorage.getItem("dealerToken");
    this.dealerToken = token;
    // this.fetchMapsData(token);
    this.listLoading = true;
    this.fetchUserInfo(token);
    this.fetchEmployeesList(token);
    this.fetchDashboardInfo(token);
  },

  mixins:[onStep1Update],

  methods: {
    changeTab(tabnumber){
      this.activeTab = tabnumber;
    },
    async fetchUserInfo(token) {
      let data = await GlobalService.getDealerSystems(token);
      if (data.systems) {
        
      /*   data.systems[0].sysstate = "0"
        data.systems[1].sysstate = "1"
        data.systems[2].sysstate = "2"
        data.systems[0].lastservice = "2021-02-01 12:21:04"
        data.systems[1].lastservice = "2020-06-01 12:21:04"
        data.systems[2].lastservice = "2019-03-01 12:21:04" */

        this.systemData = data.systems;
        this.filteredData = data.systems;
      }
      if (this.systemData && this.systemData.length) {
        this.center = L.latLng(this.systemData[0].geolat, this.systemData[0].geolng);
      }
    },
    async fetchEmployeesList(token) {
      let data = await GlobalService.getEmployeesList(token);
      if (data.employees) {
        this.employeesData = data.employees
        this.listLoading = false;
      }
    },
    async fetchDashboardInfo(token){
      this.dealerDashbaord = await GlobalService.getDealerDashboard(token);
    },
    markerClicked(box) {
      this.systemItem = box;
      this.openInfoModal = true;
      /* router.push("/event-logs"); */
    },
    chooseMapPin(status, type) {
      if (status === "0") {
        return type === "map" ? require("../../assets/icons/green-pin.png") : "status-0";
      } else if (status === "1") {
        return type === "map" ? require("../../assets/icons/red-pin.png") : "status-1";
      } else {
        return type === "map" ? require("../../assets/icons/grey-pin.png") : "status-other";
      }
    },
    
    renderMarkersTooltip(item){
      if (item.sysstate === "0") {
        return translateFunc('lng_marker_green');
      } else if (item.sysstate === "1") {
        return translateFunc('lng_marker_red');
      } else {
        return translateFunc('lng_marker_grey');
      }
    },
    closeInfoModalFunc(){
      this.openInfoModal = false;
    },
    closeAddSystemModalFunc(){
      this.openAddSystemModal = false
    },
    findMonthsForService(item){
      if(item.lastservice){
        let monthDifference =  moment(new Date()).diff(new Date(item.lastservice), 'months', true);
        if(monthDifference <= 9){
          return "no"
        } else if(monthDifference <= 12){
          return "soon"
        } else if(monthDifference > 12){
          return "due"
        }
      }
    },
    async assignEmployee(item){
      let data = await GlobalService.assignEmployeeToSystem(this.dealerToken, item.id, item.employee.id);
      if (data.status !== 0) {
        this.fetchUserInfo(this.dealerToken);
      }
    },
    closeFiltersModalFunc(){
      this.openFiltersModal = false;
    },
    async applyFilters(conditions){
      let data1 = this.systemData;
      let data2 = this.systemData;
      let data3 = this.systemData;
      if(conditions.employee || conditions.service || conditions.state){
        if(conditions.employee){
          data1 = await this.systemData.filter(a =>{
            if(a.employee === conditions.employee.id){
              return 1;
            }
          })
          this.filteredData = data1;
        }
        if(conditions.service){
          data2 = await data1.filter(a =>{
            if(this.findMonthsForService(a) === conditions.service){
              return 1;
            }
          })
          this.filteredData = data2;
        }
        if(conditions.state){
          data3 = await data2.filter(a =>{
            if(a.sysstate === conditions.state){
              return 1;
            }
          })
          this.filteredData = data3;
        }
      } else {
        this.filteredData = this.systemData;
      }
    }
  }
};
</script>
<style scoped>
.status-0 {
  background-color: rgb(130,225,147)
}
.status-1 {
  background-color: rgb(225,128,128)
}
.status-other {
  background-color: rgb(223,217,217)
}
.home-page {
  height: 100%;
}
.d-menu-bar {
  display: flex;
  align-items: center;
  justify-content: center;
}
.floating-button-container {
  position: absolute;
  top: 3rem;
  right: 3rem;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-end;
}
.floating-button-container .v-btn {
  margin-bottom: 0.5rem;
}
.alert-on-map {
  position: absolute !important;
  right: 20px;
  z-index: 9999;
  bottom: 0;
}
.map-container {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.v-card {
  box-shadow: 0px 0px 0px 0px !important;
}
.map-height {
  height: calc(100vh - 80px);
}
.v-tabs {
  flex: 0 !important;
}
@media only screen and (max-width: 768px){
  .map-height {
    height: calc(100vh - 65px);
  } 
}
</style>